import { startOfDay, subMonths } from "date-fns";

export const HISTORY_MAX_LOOKBACK_MONTHS = 13;

export function getEarliestSelectableDate(now: Date = new Date()) {
  return startOfDay(subMonths(now, HISTORY_MAX_LOOKBACK_MONTHS));
}
